export default __webpack_public_path__ + "static/media/381.63e51114.png";